"use client";
import DarkCard from "containers/DarkCard";
import Input from "components/formFields/Input";
import ButtonPanel from "components/ButtonPanel";
import { SubmitHandler, useForm } from "react-hook-form";
import { RequestPasswordResetDocument } from "graphql/generated-types";
import { useState } from "react";
import { fetchGraphQL } from "utils/request";

type Inputs = {
	email: string;
};

const ForgotPassword: React.FC = () => {
	const { handleSubmit, control } = useForm<Inputs>();
	const [showSuccess, setShowSuccess] = useState(false);
	const [isLoading, setIsLoading] = useState(false);

	const onSubmit: SubmitHandler<Inputs> = async (data) => {
		setIsLoading(true);
		const response = await fetchGraphQL(RequestPasswordResetDocument, data);
		if (response.data?.requestPasswordReset?.success) {
			setShowSuccess(true);
		}
		setIsLoading(false);
	};

	return (
		<DarkCard className="mx-auto max-w-xl">
			{showSuccess ? (
				<>
					<p>
						If an account with that email exists, you will receive an email with instructions on how to reset your
						password.
					</p>
					<ButtonPanel text="Back to home" href="/" className="mt-10" />
				</>
			) : (
				<>
					<h1 className="text-28px mb-10 leading-tight">
						Enter your email, we&apos;ll send you a link to reset you password
					</h1>
					<form onSubmit={handleSubmit(onSubmit)} className="flex flex-col items-start gap-10">
						<Input label="Email" type="email" formKey="email" control={control} />
						<ButtonPanel text="Submit" isLoading={isLoading} />
					</form>
				</>
			)}
		</DarkCard>
	);
};

export default ForgotPassword;
